import React from 'react';
import { CompactPicker } from 'react-color';
import styled from 'styled-components'
import {StyledLi} from '../styled-components/components'
import { connect } from 'react-redux'
import {changePresetColor} from '../actions/index'
const StyledColorBox = styled.div`

   background ${props => props.color || "#a4a4a4"};
   width:30px;
   height:30px;
   margin: 5px 0px 0px;
   box-sizing:border-box;
   border:1px solid #666;
   border-radius:50%;


`

const StyledPicker = styled.div`
    position: absolute;
    z-index: 150;
    top: 41px;
    transform: translateX(-50%);
    left: 50%;

`


class ColorSelector extends React.Component {
    constructor(props){
        super(props)
    }
    state = {
        background: '#fff',
        pickerShowing : false
    };

    handleChangeComplete = (color) => {
        this.setState({ background: color.hex });
    };
    activatePicker = () => {
      this.setState({pickerShowing: !this.state.pickerShowing});
    };
    render() {
        let ret;
        var color = this.props.settings.present.getIn([this.props.preset, "color"])
        color = color == undefined ? "#fff" : color
        if(this.state.pickerShowing) {
             ret = <StyledPicker>
                    <CompactPicker color={ color } onChange={ (color) => { this.props.dispatch(changePresetColor(this.props.preset.toString(), color.hex) )} } /></StyledPicker>
        }
        return(
                    <StyledLi><StyledColorBox color={color} onClick={this.activatePicker} />{ret}</StyledLi>
        )

    }
}

function mapStateToProps(state){

    return({
        preset : state.preset,
        settings : state.presetSettings
    })
}

export default connect(mapStateToProps)(ColorSelector)